/**
 * @generated SignedSource<<bafe70fb3e5437f84170df0692e41bbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteBlogPostInput = {
  blogPostId?: string | null | undefined;
  blogPostRawId?: number | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type BlogPostListItem_DeleteMutation$variables = {
  input: DeleteBlogPostInput;
};
export type BlogPostListItem_DeleteMutation$data = {
  readonly deleteBlogPost: {
    readonly blogPost: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type BlogPostListItem_DeleteMutation = {
  response: BlogPostListItem_DeleteMutation$data;
  variables: BlogPostListItem_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPostListItem_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteBlogPostPayload",
        "kind": "LinkedField",
        "name": "deleteBlogPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPost",
            "kind": "LinkedField",
            "name": "blogPost",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPostListItem_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteBlogPostPayload",
        "kind": "LinkedField",
        "name": "deleteBlogPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPost",
            "kind": "LinkedField",
            "name": "blogPost",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86061bede694a67c2c816a9894329c3f",
    "id": null,
    "metadata": {},
    "name": "BlogPostListItem_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BlogPostListItem_DeleteMutation(\n  $input: DeleteBlogPostInput!\n) {\n  deleteBlogPost(input: $input) {\n    blogPost {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dc7152d539a12368bae68a27d57dad2";

export default node;
